export const copyShader = {
    uniforms: {
        tDiffuse: {
            type: "t",
            value: null
        },
        opacity: {
            type: "f",
            value: 1
        },
        depthTex: {
            type: "t",
            value: null
        } 
    },
    vertexShader: ` 
        varying vec2 vUv;
        void main() {
            vUv = uv; 
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
    `,
    fragmentShader: `
        #extension GL_EXT_frag_depth : enable
        uniform float opacity;
        uniform sampler2D tDiffuse;
        #if defined(GL_EXT_frag_depth) && defined(useDepth)  
            uniform sampler2D depthTex;
        #endif
        
        varying vec2 vUv;
        void main() { 
            #if defined(GL_EXT_frag_depth) && defined(useDepth) 
                float depth = texture2D(depthTex, vUv).r;
                /* if(depth >= 1.0){ //超级远（但是在modelTex里我把天空距离超出far了，所以不删）
                    discard;
                } */
                gl_FragDepthEXT = depth; 
            #endif
            
            
            
            vec4 texel = texture2D( tDiffuse, vUv );
            gl_FragColor = opacity * texel; 
            
            
        } 
     `    
}

 